import { render, staticRenderFns } from "./CardPhotoGroupComponent.vue?vue&type=template&id=673e9a77"
import script from "./CardPhotoGroupComponent.vue?vue&type=script&lang=js"
export * from "./CardPhotoGroupComponent.vue?vue&type=script&lang=js"
import style0 from "./CardPhotoGroupComponent.vue?vue&type=style&index=0&id=673e9a77&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports